export function getUserInfo() {
    var wixClient = getCookieValue('wixClient').split('|');
    var id = wixClient[6] || getCookieValue('_wixCIDX');
    return {
        id: id,
    };
}
function getCookieValue(name) {
    return (document.cookie.match(name + "=([^;]*)") || ['']).pop();
}
//# sourceMappingURL=user.js.map